/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  UpdateOtelDestinationInput,
  UpdateOtelDestinationInput$Outbound,
  UpdateOtelDestinationInput$outboundSchema,
} from "./updateoteldestinationinput.js";

/**
 * Destination transport type.
 */
export const UpdateDestinationRequestBodyDestinationType = {
  Otel: "otel",
} as const;
/**
 * Destination transport type.
 */
export type UpdateDestinationRequestBodyDestinationType = ClosedEnum<
  typeof UpdateDestinationRequestBodyDestinationType
>;

/**
 * Sensitive-data policy.
 */
export const UpdateDestinationRequestBodySensitiveData = {
  Exclude: "exclude",
  Include: "include",
} as const;
/**
 * Sensitive-data policy.
 */
export type UpdateDestinationRequestBodySensitiveData = ClosedEnum<
  typeof UpdateDestinationRequestBodySensitiveData
>;

export type UpdateDestinationRequestBody = {
  /**
   * Destination transport type.
   */
  destinationType: UpdateDestinationRequestBodyDestinationType;
  /**
   * Human-readable destination name.
   */
  name: string;
  /**
   * OTEL-specific configuration supplied when updating a destination.
   */
  otel?: UpdateOtelDestinationInput | undefined;
  /**
   * Sensitive-data policy.
   */
  sensitiveData: UpdateDestinationRequestBodySensitiveData;
};

/** @internal */
export const UpdateDestinationRequestBodyDestinationType$outboundSchema:
  z.ZodMiniEnum<typeof UpdateDestinationRequestBodyDestinationType> = z.enum(
    UpdateDestinationRequestBodyDestinationType,
  );

/** @internal */
export const UpdateDestinationRequestBodySensitiveData$outboundSchema:
  z.ZodMiniEnum<typeof UpdateDestinationRequestBodySensitiveData> = z.enum(
    UpdateDestinationRequestBodySensitiveData,
  );

/** @internal */
export type UpdateDestinationRequestBody$Outbound = {
  destination_type: string;
  name: string;
  otel?: UpdateOtelDestinationInput$Outbound | undefined;
  sensitive_data: string;
};

/** @internal */
export const UpdateDestinationRequestBody$outboundSchema: z.ZodMiniType<
  UpdateDestinationRequestBody$Outbound,
  UpdateDestinationRequestBody
> = z.pipe(
  z.object({
    destinationType: UpdateDestinationRequestBodyDestinationType$outboundSchema,
    name: z.string(),
    otel: z.optional(UpdateOtelDestinationInput$outboundSchema),
    sensitiveData: UpdateDestinationRequestBodySensitiveData$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      destinationType: "destination_type",
      sensitiveData: "sensitive_data",
    });
  }),
);

export function updateDestinationRequestBodyToJSON(
  updateDestinationRequestBody: UpdateDestinationRequestBody,
): string {
  return JSON.stringify(
    UpdateDestinationRequestBody$outboundSchema.parse(
      updateDestinationRequestBody,
    ),
  );
}
